/**
 * user - login
 *
 * @author Shigq
 * @date 2021/6/3 11:42
 */
import { t, REQ_ITEM_TYPE, validatorComp } from '../base'

const { validateDrag } = validatorComp()

const LoginReq = [
  {
    prop: 'zoneNumber',
    type: REQ_ITEM_TYPE.SELECT,
    default: '+86'
  }, {
    prop: 'loginName',
    label: {
      cellphone: t('user.login.placeholder.text_2'),
      email: t('user.login.placeholder.text_1')
    },
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('user.login.error.text_2') }
    ],
    default: ''
  }, {
    prop: 'password',
    label: t('user.login.placeholder.text_3'),
    type: REQ_ITEM_TYPE.INPUT,
    rules: [
      { required: true, trigger: 'blur', message: t('user.login.error.text_3') }
    ],
    default: ''
  }, {
    prop: 'drag',
    rules: [
      { required: true, trigger: 'change', validator: validateDrag }
    ],
    default: false
  }
]

export {
  LoginReq
}
